import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getInitials } from "../../../util/text";
import { ChevronRightIcon } from "./Icons.jsx";
import s from "./RelatedShops.module.css";
import { captureWithShop } from "../../../services/posthogCapture";
import { RELATED_SHOP_CLICKED } from "../../../services/posthogEvents.js";
import { Skeleton } from "../../../themeV2";

export default function RelatedShops({
  isLoading,
  productTags,
  excludeTag,
  influencerId,
}) {
  if (isLoading) {
    return (
      <section className={s.root} aria-label="Related shops">
        <div className={s.container}>
          <div className={s.header}>
            <Skeleton variant="text" size="xl" style={{ width: 200 }} />
          </div>
          <Skeleton variant="text" style={{ width: 260 }} />
          <div className={s.skeletonRow}>
            {Array.from({ length: 4 }, (_, i) => (
              <Skeleton variant="rect" className={s.skeletonCard} key={i} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!productTags || productTags.length === 0) return null;

  const filtered = excludeTag
    ? productTags.filter((tag) => tag.tagString !== excludeTag)
    : productTags;

  if (filtered.length === 0) return null;

  return (
    <section className={s.root} aria-label="Related shops">
      <div className={s.container}>
        <div className={s.header}>
          <h2 className={s.heading}>Discover More</h2>
          <span className={s.count}>
            {filtered.length} collection{filtered.length !== 1 ? "s" : ""}
          </span>
        </div>
        <p className={s.subtext}>
          Explore other shops and collections you might enjoy
        </p>
        <div className={s.list}>
          {filtered.map((tag) => (
            <Link
              onClick={() => {
                if (!influencerId || !tag.shopInfluencerId) return;
                captureWithShop(
                  RELATED_SHOP_CLICKED,
                  {
                    from_shop_id: influencerId,
                    to_shop_id: tag.shopInfluencerId,
                  },
                  tag.shopInfluencerId,
                );
              }}
              key={tag.tagString}
              to={`/${tag.shopRoute}`}
              className={s.card}
            >
              {tag.shopAvatarUrl ? (
                <img className={s.avatar} src={tag.shopAvatarUrl} alt="" />
              ) : (
                <span className={s.avatarFallback} aria-hidden="true">
                  {getInitials(tag.shopName)}
                </span>
              )}
              <div className={s.cardText}>
                <div className={s.cardName}>{tag.shopName}</div>
                <div className={s.cardLabel}>Collection</div>
              </div>
              <ChevronRightIcon className={s.arrow} />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

RelatedShops.propTypes = {
  isLoading: PropTypes.bool,
  productTags: PropTypes.arrayOf(
    PropTypes.shape({
      tagString: PropTypes.string.isRequired,
      shopRoute: PropTypes.string.isRequired,
      shopName: PropTypes.string.isRequired,
      shopAvatarUrl: PropTypes.string,
    }),
  ),
  excludeTag: PropTypes.string,
  influencerId: PropTypes.number,
};
